import React, { useEffect, useState, useRef } from 'react'
import Api from '../../../../_helpers/Api'
import Skeleton from 'react-loading-skeleton'
import '../../../../assets/css/partials/TodosStatsPerEmployee.css'
import { trans } from '../../../../_providers/Translation'
import GroupedBarChart from '../../../partials/GroupedBarChart'
import { getPaletteColor } from '../../../partials/chartTheme'
import { Button } from '@mui/material'
import CompactFilterLayout from '@/components/partials/CompactFilterLayout'
import DateRange from '@/components/partials/DateRange'
import filterImage from '@/assets/img/icons/filter.svg'
import EmployeeCountDiagram from './EmployeeCountDiagram'

const INITIAL_FILTERS = {
    date_from: null,
    date_to: null,
    employee_id: null,
}

export default function ClosedByTech({
    endpoint = 'dashboard/todos-stats-per-employee',
    title = trans('labels.closedByTech')
}) {
    const [state, setState] = useState({ loading: true, data: null, employees: [] })
    const [filters, setFilters] = useState(INITIAL_FILTERS)

    const compactFilterLayoutRef = useRef(null)
    const fetchDebounceRef = useRef(null)

    useEffect(() => {
        loadEmployees()
    }, [])

    useEffect(() => {
        clearTimeout(fetchDebounceRef.current)
        fetchDebounceRef.current = setTimeout(() => {
            setState(prev => ({ ...prev, loading: true }))
            Api.get(`${endpoint}?date_from=${filters.date_from || ''}&date_to=${filters.date_to || ''}`)
                .then(res => {
                    const payload = res?.data ?? res
                    setState(prev => ({ ...prev, loading: false, data: payload }))
                })
                .catch(() => {
                    setState(prev => ({ ...prev, loading: false, data: null }))
                })
        }, 300)
        return () => clearTimeout(fetchDebounceRef.current)
    }, [endpoint, filters])

    function handleFilterChange(name, value) {
        setFilters(prev => ({ ...prev, [name]: value }))
    }

    function getAppliedFiltersCount() {
        return filters.date_from || filters.date_to ? 1 : 0
    }

    const employeeData = Array.isArray(state.data) ? state.data : []

    const loadEmployees = () => {
        Api.get('partners/employees/all?active=1&sort=name')
            .then(res => {
                setState(prev => ({
                    ...prev,
                    employees: res.data || []
                }))
            })
            .catch(err => {
                console.error('Error loading employees:', err)
            })
    }

    return (
        <div className="todos-stats-chart">
            <div className="head">
                <h3>{title}</h3>
                <div className="right">
                    <Button onClick={(e) => compactFilterLayoutRef.current.open(e)}>
                        <img src={filterImage} alt="Filter" />
                        {getAppliedFiltersCount() ?
                            <i>
                                {getAppliedFiltersCount()}
                            </i>
                            :
                            <></>
                        }
                    </Button>
                    <CompactFilterLayout
                        ref={compactFilterLayoutRef}
                        appliedFiltersCount={getAppliedFiltersCount()}
                        onClearClick={() => setFilters(INITIAL_FILTERS)}
                    >
                        <div className='row'>
                            <div className='col'>
                                <DateRange
                                    startDate={filters.date_from || ''}
                                    endDate={filters.date_to || ''}
                                    onStartDateChange={(date) => handleFilterChange('date_from', date)}
                                    onEndDateChange={(date) => handleFilterChange('date_to', date)}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <select
                                    value={filters.employee_id || ''}
                                    name='employee_id'
                                    onChange={(e) => handleFilterChange('employee_id', e.target.value)}
                                >
                                    <option value="">{trans('random.allUsers')}</option>
                                    {state.employees.map(employee => (
                                        <option key={employee.id} value={employee.id}>
                                            {employee.name} {employee.lastname}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </CompactFilterLayout>
                </div>
            </div>
            <hr />
            {state.loading
                ? <Skeleton height={360} count={1} />
                : <EmployeeCountDiagram
                    title={trans('labels.adminCreated')}
                    endpoint="dashboard/diagram/closed-by-tech"
                    filters={filters}
                />
            }
        </div>
    )
}
